var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { msg, localized } from '@lit/localize';
let InputTextArea = class InputTextArea extends LitElement {
    constructor() {
        super(...arguments);
        this.placeholder = '';
        this.value = '';
        this.size = 'medium';
        this.variant = 'primary';
    }
    handleInput(e) {
        const target = e.target;
        this.value = target.value;
        this.dispatchEvent(new CustomEvent('input-text-area', {
            detail: this.value,
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        const variantClass = `text-area--${this.variant}`;
        const sizeClass = `text-area--${this.size}`;
        return html `
      <textarea
        class="text-area ${variantClass} ${sizeClass}"
        .value=${this.value}
        placeholder=${this.placeholder || msg('Text area...', { id: 'form.placeholder.textArea', desc: 'Text area placeholder' })}
        @input=${this.handleInput}
      ></textarea>
    `;
    }
};
InputTextArea.styles = css `
    .text-area {
      padding: 8px 12px;
      border: 1px solid #ddd;
      border-radius: 8px;
      font-size: 14px;
      width: 100%;
      box-sizing: border-box;
      transition: border 0.3s, box-shadow 0.3s;
      resize: vertical;
    }

    .text-area:focus {
      border-color: #0078d4;
      box-shadow: 0 0 0 3px rgba(0, 120, 212, 0.2);
      outline: none;
    }

    /* Variants */
    .text-area--primary {
      border-color: #0078d4;
    }

    .text-area--secondary {
      border-color: #6c757d;
    }

    .text-area--success {
      border-color: #28a745;
    }

    .text-area--danger {
      border-color: #dc3545;
    }

    .text-area--warning {
      border-color: #ffc107;
    }

    /* Sizes */
    .text-area--small {
      font-size: 12px;
      padding: 6px 10px;
    }

    .text-area--medium {
      font-size: 14px;
      padding: 8px 12px;
    }

    .text-area--large {
      font-size: 20px;
      padding: 10px 14px;
    }
  `;
__decorate([
    property({ type: String })
], InputTextArea.prototype, "placeholder", void 0);
__decorate([
    property({ type: String })
], InputTextArea.prototype, "value", void 0);
__decorate([
    property({ type: String })
], InputTextArea.prototype, "size", void 0);
__decorate([
    property({ type: String })
], InputTextArea.prototype, "variant", void 0);
InputTextArea = __decorate([
    localized(),
    customElement('input-text-area')
], InputTextArea);
export { InputTextArea };
//# sourceMappingURL=InputTextArea.js.map